<button
  class="tooltip-wrapper"
  type="button"
  #tooltipButton
  [ngClass]="[position, !marginBottom ? 'margin-bottom-false' : '']"
  (click)="openTooltip()"
  attr.aria-label="{{ 'airaLabel.showReinvestmentInfo' | translate }}">
  <i
    class="bi bi-question-circle tooltip-circle"
    [ngClass]="{ 'with-margin': withMargin, 'margin-bottom': marginBottom }"
    alt="tooltip icon"></i>

  <ng-container>
    <div #triangle class="triangle"></div>
    <div #lnaTooltip class="lna-tooltip">
      <p #tooltipText>{{ 'components.tooltip.' + text | translate }}</p>
      @if (isClamped) {
        <button type="button" (click)="isModalOpen = true" class="link link-btn">{{ 'components.tooltip.showMore' | translate }}</button>
      }
    </div>
  </ng-container>
</button>
<app-tooltip-modal (cancel)="isModalOpen = false" [isOpen]="isModalOpen" [text]="'components.tooltip.' + text | translate"></app-tooltip-modal>
